
        require('./index.scss');
        'use strict';

var $ = window.$;
var head = $('.list-header');
var body = $('.list-body');
var page = $('#pagination');
var cate = $('#category');
var items = $('.list-item');

function getList(curr, total) {
    if (curr > total) curr = total;
    var ls = [];
    var right = total - curr > 3 ? 3 : total - curr;
    var left = curr - 1 > 3 ? 3 : curr - 1;
    var start = curr - left;
    var end = curr + right;
    if (right > 0 && left > 0) {
        for (var i = start; i <= end; i++) {
            ls.push(i);
        }
    } else if (right > 0) {
        for (var _i = curr; _i <= end; _i++) {
            ls.push(_i);
        }
    } else if (left > 0) {
        for (var _i2 = start; _i2 <= curr; _i2++) {
            ls.push(_i2);
        }
    } else if (curr === total) {
        ls = [1];
    }
    return ls;
}

var _module = {
    init: function init() {
        var that = this;
        var curr = Number(page.attr('data-current-page'));
        var total = Number(page.attr('data-pages'));
        var next = curr + 1 > total ? total : curr + 1;
        var previous = curr - 1 < 1 ? 1 : curr - 1;
        var cateInfo = cate.attr('data-cate');
        var listHead = cate.find('li:not(".all")');
        var name = cate.attr('data-cate-name');
        var all = cate.find('.all-category').find('li');
        var display = [];
        for (var i = 0; i < cate.find('.head').length; i++) {
            display.push(cate.find('.head')[i].innerText);
        }
        for (var _i3 = 0; _i3 < all.length; _i3++) {
            if (display.indexOf(all.find('a')[_i3].innerText) > -1) {
                cate.find('.all-category').find('li').eq(_i3).css('display', 'none');
            }
        }
        for (var _i4 = 0; _i4 < items.length; _i4++) {
            if (items.eq(_i4).find('.list-item-headimage').length) {
                items.eq(_i4).find('.list-item-content').css('width', '680px');
            }
        }
        var list = cate.find('li');
        if (list.length > 20) {
            var up = $('<em class="icon">&#xe8f3;</em>');
            var down = $('<em class="icon">&#xe8f5;</em>');
            var tag = $('<div class="more"><span>更多</span><em class="icon">&#xe8f5;</em></div>');
            cate.append(tag);
            cate.find('.more').mouseover(function () {
                cate.find('.more').attr('class', 'red more');
            });
            cate.find('.more').mouseout(function () {
                cate.find('.more').attr('class', 'more');
            });
            cate.find('.more').click(function () {
                cate.find('.all-category').toggleClass('show');
                if (cate.find('.all-category').attr('class').indexOf('show') > -1) {
                    body.find('.list-item:first').attr('style', 'border-top:none');
                    cate.find('.more span').text('收起');
                    cate.find('.more em').remove();
                    cate.find('.more span').after(up);
                    cate.find('.all-category').css('display', 'block');
                } else {
                    cate.find('.more span').text('更多');
                    cate.find('.more em').remove();
                    cate.find('.more span').after(down);
                    body.find('.list-item:first').attr('style', '');
                    cate.find('.all-category').css('display', 'none');
                }
            });
        }
        for (var _i5 = 0; _i5 < list.length; _i5++) {
            if (list[_i5].innerText == name) {
                list.eq(_i5).addClass('active');
                if (_i5 >= 18) {
                    // 前十个分类被加了两次所以是用20限制的
                    cate.find('.all-category').addClass('show');
                    body.find('.list-item:first').attr('style', 'border-top:none');
                    cate.find('.more span').text('收起');
                    cate.find('.more em').remove();
                    cate.find('.more span').after(up);
                    cate.find('.all-category').css('display', 'block');
                } else {
                    cate.find('.all-category').css('display', 'none');
                }
            }
        };

        var ls = getList(curr, total);

        if (ls.length) {
            var len = ls.length;
            for (var _i6 = ls[len - 1]; _i6 >= ls[0]; _i6--) {
                var li = $('<li class="num">' + _i6 + '</li>');
                if (_i6 === curr) li.attr('class', 'active');
                if ($('#previous-page')[0]) {
                    $('#previous-page').after(li);
                } else if ($('#start-page')[0]) {
                    $('#start-page').after(li);
                }
            }
            if (ls[len - 1] < total) {
                $('.num:last').after($('<span>...</span><li>' + total + '</li>'));
            }
            if (ls[0] > 1) {
                $('.num:first').before($('<li>1</li><span>...</span>'));
            }
        }
        page.find('li').click(function (e) {
            var type = e.target.innerText;
            switch (type) {
                case '上一页':
                    that.goto(previous);
                    break;
                case '首页':
                    that.goto(1);
                    break;
                case '下一页':
                    that.goto(next);
                    break;
                case '末页':
                    that.goto(total);
                    break;
                default:
                    that.goto(type);
            };
        });
        this.checkImgUrl();
    },
    checkImgUrl: function checkImgUrl() {
        var imgs = $('.list-item-headimage');
        for (var i = 0; i < imgs.length; i++) {
            var src = imgs[i].getAttribute('data-src');
            src = src.indexOf('http') > -1 ? src : 'https://t.focus-img.cn/sh160x120sh' + src;
            imgs.find('img')[i].src = src;
        }
    },
    goto: function goto(num) {
        var href = window.location.href;
        var path = window.location.pathname;
        if (/\/C\d+/.test(href)) {
            var preffix = /\/C\d+/.exec(href)[0];
            var target = href.replace(/\/C\d+.*/, preffix + '_n' + num + '/');
            window.location.href = target;
        } else if (/\/zixun(\/?)$/.test(path)) {
            var _target = path.replace(/\/zixun(\/?)$/, '/zixun/n' + num + '/');
            window.location.href = _target;
        } else if (/\/gonglue(\/?)$/.test(path)) {
            var _target2 = path.replace(/\/gonglue(\/?)$/, '/gonglue/n' + num + '/');
            window.location.href = _target2;
        } else if (/\/(zixun|gonglue)\/n\d+/.test(path)) {
            var _target3 = path.replace(/\/(zixun|gonglue)\/n\d+/, '/$1/n' + num + '/');
            window.location.href = _target3;
        }
    }
};

_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/home-list/list/index.js